import React, { useRef } from "react";
import Link from "next/link";
import {
  Badge,
  IconButton,
  InputAdornment,
  TextField,
  Toolbar,
  Tooltip
} from "@material-ui/core";
import {
  Add as AddIcon,
  Close as CloseIcon,
  DeleteSweep as DeleteSweepIcon,
  Search as SearchIcon,
  FilterList as FilterListIcon
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2, 2)
  },
  buttons: {
    flex: "1 1 100%",
    justifyContent: "flex-start"
  },
  filter: {
    flex: "0 0 auto",
    justifyContent: "flex-start",
    paddingRight: theme.spacing(2)
  },
  filterList: {},
  searchTerm: {
    minWidth: "240px",
    width: "45%",
    fontSize: "0.875rem",

    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: 0
    }
  }
}));

interface Props {
  searchTermLabel?: string;
  pathCreate?: string;
  onChangeSearchTerm: (searchTerm?: string) => void;
  handleOpenFilter?: () => void;
  activeFilterCount?: number;
  handleClickDelete?: () => void;
  deletingCount?: number;
}

const DataTableToolbar: React.FC<Props> = props => {
  const {
    searchTermLabel,
    pathCreate,
    onChangeSearchTerm,
    handleOpenFilter,
    activeFilterCount,
    handleClickDelete,
    deletingCount,
    children
  } = props;
  const classes = useStyles();
  const searchTermRef = useRef<HTMLInputElement>(null);

  const handleChangeSearchTerm = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    onChangeSearchTerm(e.target.value ?? "");
  };

  const handleClearSearchTerm = () => {
    if (searchTermRef.current) {
      searchTermRef.current.value = "";
    }
    onChangeSearchTerm(undefined);
  };

  return (
    <Toolbar className={classes.root}>
      <div className={classes.buttons}>
        {pathCreate && (
          <Link href={pathCreate}>
            <a>
              <Tooltip title="เพิ่มรายการ">
                <IconButton aria-label="เพิ่มรายการ">
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </a>
          </Link>
        )}

        {handleClickDelete && (
          <Tooltip title="ลบรายการที่เลือก" key="delete">
            <span>
              <IconButton
                aria-label="Delete"
                onClick={handleClickDelete}
                disabled={!deletingCount}
              >
                <Badge
                  badgeContent={deletingCount ?? 0}
                  color="primary"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                  }}
                >
                  <DeleteSweepIcon />
                </Badge>
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
      <div className={classes.filter}>
        {handleOpenFilter && (
          <Tooltip title="Filter list" key="filter">
            <IconButton aria-label="Filter list" onClick={handleOpenFilter}>
              <Badge
                badgeContent={activeFilterCount ?? 0}
                color="primary"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
              >
                <FilterListIcon />
              </Badge>
            </IconButton>
          </Tooltip>
        )}
      </div>

      {children}

      <TextField
        className={classes.searchTerm}
        variant="outlined"
        name="searchCriteria"
        placeholder={searchTermLabel}
        inputRef={searchTermRef}
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="Clear"
                onClick={handleClearSearchTerm}
                disabled={!searchTermRef.current?.value}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        onChange={handleChangeSearchTerm}
      />
    </Toolbar>
  );
};

export default DataTableToolbar;
